import { Outlet } from 'react-router-dom';
// material
import { styled, useTheme } from '@material-ui/core';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// components
import { MHidden } from '../../components/@material-extend';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import MobileBottomNav from './MobileBottomNav';

// ----------------------------------------------------------------------

const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  // No fixed AppBar to clear on mobile anymore (DashboardNavbar is desktop-only below), so this
  // is just a normal top margin rather than app-bar-height compensation.
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();

  return (
    <RootStyle>
      <MHidden width="lgDown">
        <DashboardNavbar />
      </MHidden>
      <DashboardSidebar />
      <MainStyle
        sx={{
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex
          }),
          ...(collapseClick && {
            ml: '102px'
          })
        }}
      >
        <Outlet />
      </MainStyle>
      <MobileBottomNav />
    </RootStyle>
  );
}
